import ToggleButton from 'Components/Common/components/Inputs/ToggleButton';
import {
    CLASS,
    CUSTOM_LABEL,
    ENTER,
    ENTER_LABEL,
    LABEL,
    MANAGE,
    MAX,
    MAX_INSTANTIATION,
    MIN,
    MIN_INSTANTIATION,
    MULTIPLE_INSTANTIATION,
    PROJECT_NAME,
    QUANTITY,
    REQUIRED,
    SUB_MODEL_DETAILS,
    SUB_MODEL_NAME
} from 'Pages/GMS/ISR/ISRConstants';
import React, { useEffect, useState } from 'react';
import { TConnector, TField, TFieldClass, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput } from '../model';
import { ClassIcon, GearIcon } from 'assests/GmsIcons';
import ManageClassDialog from './ManageClassDialog';
import { useISRContext } from 'Pages/GMS/ISR/Hooks/useISRContext';
import { getAllProjectClass } from '../ModelServices/ModalServices';

type SubModelDetailsProps = {
    id: string;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    setUserProjectDataModels: React.Dispatch<React.SetStateAction<TUpsertISRProjectDataModelsInput>>;
    indexInfo: TIndexState;
    projectId?: string;
}

const SubModelDetails = ({id, selectedItem, setUserProjectDataModels, indexInfo, projectId}: SubModelDetailsProps) => {
    const initializeClass = { id: null, name: '', type: '', colour: '' };
    const [submodelInfo, setSubmodelInfo] = useState<TSubmodel>({ type: "Submodel",
        data: { name: '', label: '', class: initializeClass, canSetCustomLabel: false, minInstantiation: 1, maxInstantiation: 1, fields: [], productCategories: [], connectors: [], required: false},
    });
    const isrContext = useISRContext();

    const [showClassMenu, setShowClassMenu] = useState<boolean>(false);

    const openConnectorMenu = () => setShowClassMenu(true);

    useEffect(() => {
        setSubmodelInfo(selectedItem as TSubmodel);
    }, [selectedItem]);

    useEffect(() => {
        console.log("cokdkdkdk", submodelInfo);
        updateSubmodelInDataModels(submodelInfo);
    }, [submodelInfo]);

    const handleLabelChange = (value: string) => {
        setSubmodelInfo((prevConfig) => ({ ...prevConfig, data: { ...prevConfig.data, label: value,},}));
    };

    const handleProjectNameChange = (value: string) => {
        setSubmodelInfo((prevConfig) => ({ ...prevConfig, data: { ...prevConfig.data, name: value,},}));
    };

    const handleCustomLabelChange = (value: boolean) => {
        setSubmodelInfo((prevConfig) => ({ ...prevConfig, data: { ...prevConfig.data, canSetCustomLabel: value,},}));
    };

    const handleMinInstancesChange = (value: number) => {
        setSubmodelInfo((prevConfig) => ({ ...prevConfig, data: { ...prevConfig.data, minInstantiation: value,},}));
    };

    const handleMaxInstancesChange = (value: number) => {
        setSubmodelInfo((prevConfig) => ({ ...prevConfig, data: { ...prevConfig.data, maxInstantiation: value,},}));
    };

    const handleMinChange = (value: number) => {
        setSubmodelInfo((prevConfig) => ({ ...prevConfig, data: { ...prevConfig.data, min: value,},}));
    };

    const handleMaxChange = (value: number) => {
        setSubmodelInfo((prevConfig) => ({ ...prevConfig, data: { ...prevConfig.data, max: value,},}));
    };

    const updateSubmodelInDataModels = (updatedSubmodel: TSubmodel) => {
        setUserProjectDataModels((prevDataModels) => {
            const newDataModels = { ...prevDataModels };
            const dataModels = newDataModels.project.dataModels;

            if (indexInfo && indexInfo.dataModelIndex !== null && indexInfo.dataModelIndex >= 0 && indexInfo.dataModelIndex < dataModels.length) {
                const existingSubmodel = dataModels[indexInfo.dataModelIndex];
                
                const updatedData = {
                    ...existingSubmodel.data,
                    ...updatedSubmodel.data,
                };
        
                dataModels[indexInfo.dataModelIndex] = {
                    ...existingSubmodel,
                    data: updatedData,
                };
            }
        return newDataModels;});
    };

    const handleClassChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = event.target.value;
        const selectedObject: TFieldClass = isrContext?.modelClasses?.find((item: TFieldClass) => item.name === selectedValue);
        setSubmodelInfo((prevConfig) => ({ ...prevConfig, data: { ...prevConfig.data, class: selectedObject,},}));
    };

    const handleRequiredChange = (value: boolean) => {
        setSubmodelInfo((prevConfig) => ({ ...prevConfig, data: { ...prevConfig.data, required: value,},}));
    };

    useEffect(() => {
        fetchAllClasses();
    }, []);

    const fetchAllClasses = async () => {
        try {
            const responseData = await getAllProjectClass(projectId ?? '');
            if (responseData?.done) {
                isrContext?.setFieldClasses(responseData?.data?.fieldClasses ?? []);
                isrContext?.setModelClasses(responseData?.data?.modelClasses ?? []);
            } else {
                //toast.error(responseData?.message);
            }
        } catch (error) {
            console.log('Error', error);
        }
    }

    return (
        <div id={id} className='cart-style-dm'>
            <label id={`${id}-title`} className='cart-title'>{SUB_MODEL_DETAILS}</label>
            
            {/* Name and Required Section */}
            <div id={`${id}-name-section`} className='tw-flex tw-items-center tw-mt-3'>
                <div id={`${id}-name-container`} className='tw-w-[60%] tw-pe-2'>
                    <label id={`${id}-name-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{SUB_MODEL_NAME}</label>
                    <input
                        id={`${id}-name-input`}
                        className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none"
                        type='text'
                        value={submodelInfo?.data?.name ?? ''}
                        onChange={(e) => handleProjectNameChange(e.target.value)}
                        placeholder={PROJECT_NAME} 
                    />
                </div>
                <div id={`${id}-required-container`} className='tw-w-[40%] tw-ms-4'>
                    <label id={`${id}-required-label`} className='tw-text-sm tw-text-[#747593] tw-block tw-mb-2'>{REQUIRED}</label>
                    <ToggleButton
                        id={`${id}-required-toggle`}
                        name="Required"
                        value={submodelInfo?.data?.required ?? false}
                        onChange={(e) => handleRequiredChange(e.target.checked)} 
                    />
                </div>
            </div>

            {/* Label Section */}
            <div id={`${id}-label-section`} className='tw-flex tw-items-center tw-mt-3'>
                <div id={`${id}-label-container`} className='tw-w-[60%] tw-pe-2'>
                    <label id={`${id}-label-text`} className='tw-text-sm tw-text-[#747593] tw-block'>{LABEL}</label>
                    <input
                        id={`${id}-label-input`}
                        className="tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-full tw-h-9 tw-flex tw-flex-row tw-items-center tw-justify-start tw-mt-1 tw-px-2.5 tw-gap-[2px] tw-text-sm tw-text-shades-of-grey-60 tw-border-[1px] tw-border-solid tw-border-shades-of-grey-30 focus:tw-outline-none" 
                        type='text'
                        value={submodelInfo?.data?.label ?? ''}
                        onChange={(e) => handleLabelChange(e.target.value)}
                        placeholder={ENTER_LABEL} 
                    />
                </div>
                <div id={`${id}-custom-label-container`} className='tw-w-[40%] tw-ms-4'>
                    <label id={`${id}-custom-label-text`} className='tw-text-sm tw-text-[#747593] tw-block tw-mb-2'>{CUSTOM_LABEL}</label>
                    <ToggleButton
                        id={`${id}-custom-label-toggle`}
                        name="dkdkd" 
                        value={submodelInfo?.data?.canSetCustomLabel ?? false} 
                        onChange={(e) => handleCustomLabelChange(e.target.checked)} 
                    />
                </div>
            </div>

            {/* Instantiation Section */}
            <label id={`${id}-instantiation-title`} className='cart-title tw-mt-5'>{MULTIPLE_INSTANTIATION}</label>
            <div id={`${id}-instantiation-section`} className='tw-flex tw-items-center tw-mt-3'>
                <div id={`${id}-min-instantiation-container`} className='tw-w-[20%]'>
                    <label id={`${id}-min-instantiation-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{MIN_INSTANTIATION}</label>
                    <input
                        id={`${id}-min-instantiation-input`}
                        className="input-field-dm" 
                        type='number'
                        value={submodelInfo?.data?.minInstantiation ?? 1}
                        onChange={(e) => handleMinInstancesChange(Number(e.target.value))}
                        placeholder={ENTER} 
                    />
                </div>
                <div id={`${id}-max-instantiation-container`} className='tw-w-[20%] tw-ms-5'>
                    <label id={`${id}-max-instantiation-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{MAX_INSTANTIATION}</label>
                    <input
                        id={`${id}-max-instantiation-input`}
                        className="input-field-dm" 
                        type='number'
                        value={submodelInfo?.data?.maxInstantiation ?? 1}
                        onChange={(e) => handleMaxInstancesChange(Number(e.target.value))}
                        placeholder={ENTER} 
                    />
                </div>
            </div>

            {/* Quantity Section */}
            <label id={`${id}-quantity-title`} className='cart-title tw-mt-5'>{QUANTITY}</label>
            <div id={`${id}-quantity-section`} className='tw-flex tw-items-center tw-mt-3'>
                <div id={`${id}-min-quantity-container`} className='tw-w-[20%]'>
                    <label id={`${id}-min-quantity-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{MIN}</label>
                    <input
                        id={`${id}-min-quantity-input`}
                        className="input-field-dm" 
                        type='number'
                        value={submodelInfo?.data?.min ?? 0} 
                        onChange={(e) => handleMinChange(Number(e.target.value))}
                        placeholder={ENTER} 
                    />
                </div>
                <div id={`${id}-max-quantity-container`} className='tw-w-[20%] tw-ms-5'>
                    <label id={`${id}-max-quantity-label`} className='tw-text-sm tw-text-[#747593] tw-block'>{MAX}</label>
                    <input
                        id={`${id}-max-quantity-input`}
                        className="input-field-dm"
                        type='number'
                        value={submodelInfo?.data?.max ?? 0}
                        onChange={(e) => handleMaxChange(Number(e.target.value))}
                        placeholder={ENTER} 
                    />
                </div>
            </div>

            {/* Class Section */}
            <div id={`${id}-class-header`} className='tw-flex tw-items-center tw-gap-1 tw-mt-4'>
                <ClassIcon />
                <label id={`${id}-class-title`} className='cart-title'>{CLASS}</label>
            </div>
            <div id={`${id}-class-section`} className='tw-flex tw-items-center tw-mt-1 tw-pb-3'>
                <div id={`${id}-class-select-container`} className='tw-w-[30%] tw-pe-2'>
                    <select  
                        id={`${id}-class-select`}
                        className={`drop-down-dm`} 
                        value={submodelInfo?.data?.class?.name ?? ''} 
                        onChange={handleClassChange}
                    >
                        <option id={`${id}-class-default-option`} value={''}>
                            Select Class
                        </option>                                
                        {isrContext?.modelClasses?.map((item: TFieldClass, index: number) => (
                            <option 
                                id={`${id}-class-option-${index}`}
                                value={item?.name} 
                                key={item?.id ?? '' + index}
                            >
                                {item?.name}
                            </option>
                        ))}
                    </select>
                </div>
                <button 
                    id={`${id}-manage-class-btn`}
                    onClick={openConnectorMenu} 
                    className='tw-w-auto tw-cursor-pointer tw-flex tw-items-center tw-gap-1 tw-ms-4'
                >
                    <GearIcon />
                    <label id={`${id}-manage-class-label`} className='tw-text-sm tw-text-primary tw-block'>{MANAGE}</label>
                </button>
            </div>
            
            {showClassMenu ? 
                <ManageClassDialog 
                    id={`${id}-class-dialog`}
                    showClassMenu={showClassMenu} 
                    setShowClassMenu={setShowClassMenu} 
                    projectId={projectId} 
                /> 
            : null}
        </div>
    );
}

export default SubModelDetails;